import React from "react"
import { cva } from "class-variance-authority"

export interface BadgeProps {
  /**
   * Determines the theme for the badge
   */
  theme: "orange" | "cyan" | "gray"
  /**
   * Additional classNames for the badge
   */
  className?: string
  /**
   * The text to be displayed in the badge
   */
  children: React.ReactNode
}

const badgeCva = cva(
  // Base Tailwind CSS classes
  "inline-block border border-solid leading-none text-gray-900 rounded p-1",
  {
    variants: {
      // Theme-specific classes
      theme: {
        orange: "bg-orange-medium border-orange",
        cyan: "bg-cyan-medium border-cyan",
        gray: "bg-gray-100 border-gray-300",
      },
    },
    defaultVariants: {
      theme: "gray", // Default theme
    },
  }
)
/**
 * A small label meant to display helpful information about another piece of content (e.g. "News" or "Article").
 */
const Badge = ({ children, theme, className, ...other }: BadgeProps) => {
  return (
    <span className={badgeCva({ theme, className })} {...other}>
      {children}
    </span>
  )
}

export default Badge
